import { render } from "./AuthFull.vue?vue&type=template&id=2a7c908b"
import script from "./AuthFull.vue?vue&type=script&lang=js"
export * from "./AuthFull.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__